export default __webpack_public_path__ + "static/media/leaflet.0714ee45.svg";